// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1rURP","footer":"ModalError_footer__32LS0"};